import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import company from "../../../config/company";
import endpoints from "../../../config/endpoints";
import restApi from "../../../services/restApi";
import tools from "../../../utils/tools";
import "./print.css";

/**
 * A5 shipping label — sender block, receiver block and the packing list.
 * No QR code and no parcel value, per the agreed layout.
 */
const Label = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState<any>({});

  const fetchData = async () => {
    const res = await restApi(endpoints.order.index + id, true).get();
    setData(res.data || {});
  };

  useEffect(() => {
    fetchData();
  }, []);

  // the label is opened in its own tab from the order list, where there is no
  // history to go back to - close that tab, and only fall back to navigating
  // back when the page was reached in place
  const close = () => {
    if (window.opener) {
      window.close();
      return;
    }
    navigate(-1);
  };

  const address = data?.delivery?.address;
  const fa = (value: any) => tools.engNumToPersian(value ?? "") || "";

  return (
    <div className="printPage">
      {/* A5 portrait — scoped to this route so the invoice keeps its own size */}
      {/* no page margin: the label's own frame is laid out to the A5 sheet */}
      <style>{"@page { size: A5 portrait; margin: 0; }"}</style>

      <div className="printToolbar">
        <button className="primary" onClick={() => window.print()}>
          چاپ برچسب
        </button>
        <button onClick={close}>بازگشت</button>
      </div>

      <div className="labelSheet">
        <div className="labelBox">
          <div className="labelHeader">
            <div className="labelLogo">
              {company.logo && <img src={company.logo} alt={company.name} />}
              <span dir="rtl">{company.labelTitle}</span>
            </div>
            <div className="labelSender">
              <div className="labelBar">
                <span>فرستنده:</span>
                <span dir="ltr">From:</span>
              </div>
              <div className="labelSenderAddress">{fa(company.address)}</div>
              <div className="labelSenderContact">
                <div>{fa(company.labelPhone)}</div>
                <div>کد پستی: {fa(company.postalCode)}</div>
              </div>
            </div>
          </div>

          <div className="labelBar">
            <span>گیرنده:</span>
            <span dir="ltr">To:</span>
          </div>

          <div className="labelRow">
            آقا/خانم/شرکت: <b>{data?.user?.name || "—"}</b>
          </div>
          <div className="labelRow">
            استان: <b>{address?.province?.title || "—"}</b> - شهر:{" "}
            <b>{address?.city?.title || "—"}</b> - آدرس:{" "}
            {address?.description || "—"}
          </div>
          <div className="labelSplitRow">
            <div>تلفن تماس: {fa(address?.phoneNumber || data?.user?.phoneNumber)}</div>
            <div>کد پستی: {fa(address?.postalCode)}</div>
          </div>

          <div className="labelTableWrap">
          <table className="labelTable">
            <thead>
              <tr>
                <th className="colIndex">ردیف</th>
                <th>شرح کالا</th>
                <th className="colCount">تعداد</th>
              </tr>
            </thead>
            <tbody>
              {(data?.products || []).map((orderProduct, index) => (
                <tr key={orderProduct.id}>
                  <td className="colIndex">{fa(index + 1)}</td>
                  <td>{orderProduct?.product?.title || "—"}</td>
                  <td className="colCount">{fa(orderProduct?.count)}</td>
                </tr>
              ))}
              <tr>
                <td className="labelSpacer" colSpan={3} />
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Label;
